import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';

export interface VarianceItem {
  invID: number;
  invitmID: number;
  prdID: number;
  prdNameEn: string;
  prdCode: string;
  countedQty: number;
  onhandQty: number;
  variance: number;
  storageStructureID: number;
  storagePath: string;
  pcmID: number;
}

export interface VarianceDialogData {
  items: VarianceItem[];
}

export interface VarianceDialogResult {
  override: boolean;
  message: string;
  items: VarianceItem[];
}

@Component({
  selector: 'app-variance-override-dialog',
  templateUrl: './variance-override-dialog.component.html',
  styleUrls: ['./variance-override-dialog.component.scss']
})
export class VarianceOverrideDialogComponent implements OnInit {

  overrideOnhand: boolean = true;
  overrideMessage: string = '';
  displayedColumns: string[] = ['prdNameEn', 'prdCode', 'storagePath', 'countedQty', 'onhandQty', 'variance'];

  constructor(
    public dialogRef: MatDialogRef<VarianceOverrideDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: VarianceDialogData,
    private translate: TranslateService
  ) { }

  ngOnInit(): void {
  }

  onCancel(): void {
    this.dialogRef.close(null);
  }

  onFinalizeOnly(): void {
    this.dialogRef.close({
      override: false,
      message: '',
      items: []
    } as VarianceDialogResult);
  }

  onOverrideAndFinalize(): void {
    this.dialogRef.close({
      override: true,
      message: this.overrideMessage,
      items: this.data.items
    } as VarianceDialogResult);
  }

  getVarianceClass(variance: number): string {
    if (variance > 0) return 'positive-variance';
    if (variance < 0) return 'negative-variance';
    return '';
  }

  getVarianceIcon(variance: number): string {
    if (variance > 0) return 'arrow_upward';
    if (variance < 0) return 'arrow_downward';
    return '';
  }
}
